import logo from "../../images/worklogo.png"


export default function WorkLogo() {
  return (
    <img className="l-logo" src={logo} alt="me logo" />
   
  );
}